import Glide from '@glidejs/glide'

const Carousels = [],
    CONFIG_PAGE_CAROUSELS = [
        {
            'reference': 'alerts',
            'selector': '#alerts',
            'options': {
                'type': 'slider',
                'perView': 3,
                'gap': 32,
                'rewind': false,
                'breakpoints': {
                    767: {
                        'perView': 1,
                    },
                    1279: {
                        'perView': 2,
                    }
                },
                'classes': {
                    'slide': {
                        'active': 'active'
                    },
                    'arrow': {
                        'disabled': 'disabled'
                    },
                    'nav': {
                        'active': 'active'
                    }
                }
            },
        },
        {
            'reference': 'journey',
            'selector': '#journey',
            'options': {
                'type': 'slider',
                'perView': 1,
                'rewind': false,
                'classes': {
                    'slide': {
                        'active': 'active'
                    },
                    'arrow': {
                        'disabled': 'disabled'
                    },
                    'nav': {
                        'active': 'active'
                    }
                }
            }
        }
    ];

function getCurrentPerView(config) {
    const windowWidth = window.innerWidth;

    config.perView = CONFIG_PAGE_CAROUSELS[0].options.perView

    // If no breakpoints are defined, simply return the default perView value.
    if (!config.breakpoints) {
        return config.perView;
    }

    // Get an array of breakpoint entries: [breakpoint, settings]
    const breakpointEntries = Object.entries(config.breakpoints)
        .map(([bp, settings]) => [Number(bp), settings])
        .sort((a, b) => a[0] - b[0]);

    // Loop through the breakpoints in ascending order.
    for (const [bp, settings] of breakpointEntries) {
        // When window width is less than the breakpoint, use that setting.
        if (windowWidth < bp && settings.perView !== undefined) {
            return settings.perView;
        }
    }

    // If none of the breakpoints apply, return the default.
    return config.perView;
}

function enableClickOnSlides(carousel) {
    const $el = carousel?.selector;
    if (!$el) {
        return;
    }
    // Attach one event listener to the carousel root (event delegation)
    $el.addEventListener('click', (event) => {
        let slide = event.target.closest('.glide__slide'),
            slides,
            index;

        if (slide && $el.contains(slide)) {
            slides = Array.from($el.querySelectorAll('.glide__slide'));
            index = slides.indexOf(slide);

            carousel.go(`=${index}`);
        }
    });

}

// Function to update the card position based on current index
function modifyFocusPosition(event) {
    const Carousel = this?.carousel;
    if (!Carousel) {
        return;
    }

    const $el = Carousel?.selector;
    let slides, totalItems, perView, currentIndex, offsetFromEnd, positionShift;
    if (!$el) {
        return;
    }


    slides = $el.querySelectorAll('.glide__slide');
    currentIndex = Carousel.index;
    totalItems = slides.length;

    if (!Carousel.settings?.initialPerView && this?.options?.perView) {
        Carousel.settings.initialPerView = this.options.perView;
    }

    perView = getCurrentPerView(Carousel.settings);

    if (totalItems - currentIndex < perView) {
        offsetFromEnd = totalItems - currentIndex;
        positionShift = perView - offsetFromEnd;
        Carousel.update({
            focusAt: positionShift,
            perView: perView
        });
    } else {
        Carousel.update({
            focusAt: 0,
            perView: perView
        });
    }

    $el.classList.add('carousel-ready');

}

function adaptCarouselControlsToGlideJs(element) {
    let rootElement = element,
        buttonPrevious = [...rootElement.querySelectorAll('.previous')],
        buttonNext = [...rootElement.querySelectorAll('.next')];
    buttonPrevious.forEach((child) => {
        child.setAttribute('data-glide-dir', "<");
    });
    buttonNext.forEach((child) => {
        child.setAttribute('data-glide-dir', ">");
    });
    rootElement.setAttribute('data-glide-el', 'controls');
    return element;
}

function adaptCarouselNavigationToGlideJs(element) {
    let rootElement = element,
        childElements = [...rootElement.querySelectorAll('.dot')];
    childElements.forEach((child, index) => {
        child.setAttribute('data-glide-dir', `=${index}`);
    });
    rootElement.setAttribute('data-glide-el', 'controls[nav]');
    return element;
}

function adaptCarouselToGlideJs(element) {
    let rootElement = element,
        childWrapperElement = rootElement.querySelector('.ResponsiveCarousel-panels'),
        childElements = [...childWrapperElement.querySelectorAll('.ResponsiveCarousel-panel')],
        wrappingElement = document.createElement('div'),
        controls,
        navigation;

    if (!childWrapperElement) {
        return;
    }

    // Main Carousel
    wrappingElement.setAttribute('data-glide-el', 'track');
    wrappingElement.classList.add('glide__track');

    childWrapperElement.classList.add('glide__slides');
    childElements.forEach((element) => {
        element.classList.add('glide__slide');
    });

    childWrapperElement.replaceWith(wrappingElement);
    wrappingElement.appendChild(childWrapperElement);

    // Controls
    controls = [ ... rootElement.querySelectorAll('.ResponsiveCarousel-controls--arrows') ];
    if (!!controls) {
        controls.forEach( control => {
            adaptCarouselControlsToGlideJs( control );
        } );
    }

    // Navigation
    navigation = rootElement.querySelector('.ResponsiveCarousel-controls .nav');
    if (!!navigation) {
        adaptCarouselNavigationToGlideJs(navigation);
    }

    return element;
}

function getCurrentPanelIndex(nodeList) {
    let panelIndex = 0;
    [...nodeList].forEach((element, index) => {
        if(element.classList.contains('is-current')) {
            panelIndex = index;
        }
    });
    return panelIndex;
}

function init() {

    CONFIG_PAGE_CAROUSELS.forEach((item, index) => {
        let rootElement = document.querySelector(item.selector),
            reference = item.reference,
            carouselElement,
            carouselInstance,
            carouselPanels
        ;

        if (!rootElement) {
            document.body.classList.add(`responsive-carousel-${reference}-error-root-not-found`);
            return;
        }

        carouselElement = rootElement.querySelector('.ResponsiveCarousel');
        if (!carouselElement) {
            document.body.classList.add(`responsive-carousel-${reference}-error-malformed`);
            return;
        }

        carouselInstance = adaptCarouselToGlideJs(carouselElement);
        carouselPanels = carouselInstance.querySelectorAll('.ResponsiveCarousel-panel');

        item.options.startAt = getCurrentPanelIndex(carouselPanels);

        Carousels[reference] = new Glide(carouselInstance, item.options);

        // modify the Weekly Rewards carousel to keep the last item aligned to the right edge of the carousel
        if (reference === 'alerts') {
            Carousels[reference].on(['mount.after', 'run', 'resize'], modifyFocusPosition.bind({
                'carousel': Carousels[reference],
                'options': item.options,
                'reference': reference
            }));
            enableClickOnSlides(Carousels[reference]);
        } else {
            Carousels[reference].on('mount.after', () => {
                carouselElement.classList.add('carousel-ready');
            });
        }

        requestAnimationFrame(() => {
            // Your code here runs at the next animation tick.
            Carousels[reference].mount();
        });

    });

}

// Run when the DOM is ready
// Check if `window.onload` has already fired

if (document.readyState === "complete") {
    init(); // Page is already fully loaded, run immediately
} else {
    window.onload = init; // Otherwise, wait for `window.onload`
}
